var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon0LightrailWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_9",
    "data-name": "Layer 9",
    viewBox: "3.63 1.81 42 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 2px;\n      }\n\n      .cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.62963,44.81481a8,8,0,0,0,8-8v-23c0-4.8125-1-11-20-11s-20,6.1875-20,11v23a8,8,0,0,0,8,8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.62963,
    cy: 33.81481,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.62963,
    cy: 33.81481,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.62963,
    y: 12.81481,
    width: 32,
    height: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.62963,
    y1: 8.81481,
    x2: 32.62963,
    y2: 8.81481
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.62963,
    y1: 47.81481,
    x2: 37.62963,
    y2: 47.81481
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.62963,
    y1: 50.81481,
    x2: 30.62963,
    y2: 50.81481
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon0LightrailWhite);
export default __webpack_public_path__ + "static/media/icon_0_lightrail_white.9bddd5880c567b72db2dd0aefb7104df.svg";
export { ForwardRef as ReactComponent };